// extracted by mini-css-extract-plugin
export default {"reviewBody":"_v89t32"};